import { ReactNode } from 'react';

import { useResourceLinkExtensions } from '../../extensions';

export interface ResourceNameLinkProps {
  /** The resource name. */
  name: string;

  /**
   * The text to display for the resource, unless the extension
   * overrides it.
   */
  text: ReactNode;
}

/**
 * Renders a link to a resource.
 */
export const ResourceNameLink = (props: ResourceNameLinkProps) => {
  const { name, text } = props;

  const extensions = useResourceLinkExtensions();

  const extension = extensions.find(e => e.predicate({ name, text }));
  if (extension) {
    return extension.render({ name, text });
  }

  return <strong data-resource-ref={name}>{text}</strong>;
};
